/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentCategoryDto } from '../../models/content-category-dto';

export interface UserContentCategoryControllerFindAllParentWithContents$Params {
}

export function userContentCategoryControllerFindAllParentWithContents(http: HttpClient, rootUrl: string, params?: UserContentCategoryControllerFindAllParentWithContents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, userContentCategoryControllerFindAllParentWithContents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContentCategoryDto>>;
    })
  );
}

userContentCategoryControllerFindAllParentWithContents.PATH = '/api/content-category/user/parent';
